(function () {
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function padQty(scope) {
    (scope || document).querySelectorAll('.pnm-cart__qty-input').forEach(function (input) {
      if (input.dataset.padded === '1') return;
      const n = parseInt(input.value, 10);
      if (!Number.isNaN(n) && n < 10) input.value = '0' + n;
      input.dataset.padded = '1';
    });
  }

  function updateShipBar(scope) {
    const bar = (scope || document).querySelector('[data-pnm-ship]');
    if (!bar) return;
    const threshold = Number(bar.dataset.threshold) || 0;
    if (threshold <= 0) return;

    return fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        const total = cart.total_price;
        const fill = bar.querySelector('[data-pnm-ship-fill]');
        const text = bar.querySelector('[data-pnm-ship-text]');
        const remaining = bar.querySelector('[data-pnm-ship-remaining]');
        const pct = Math.min(100, Math.round((total / threshold) * 100));

        if (fill) fill.style.width = pct + '%';

        if (total >= threshold) {
          if (text && bar.dataset.success) text.textContent = bar.dataset.success;
        } else if (remaining) {
          remaining.textContent = money(threshold - total);
        }
      })
      .catch(function () {});
  }

  function refresh() {
    updateShipBar(document);
    padQty(document);
  }

  let pending;
  function refreshSoon() {
    clearTimeout(pending);
    pending = setTimeout(refresh, 60);
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('pnm:cart:added', refreshSoon);

  // Dawn's pubsub is the reliable signal: cart.js and product-form.js both
  // publish cartUpdate after a successful change. Guarded because pubsub.js
  // is not present in every Dawn version.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshSoon);
  }

  // Fallback. Observe <cart-drawer> itself, never a descendant: renderContents
  // replaces the whole .drawer__inner subtree, which would orphan the observer.
  const drawer = document.querySelector('cart-drawer');
  if (drawer && typeof MutationObserver !== 'undefined') {
    let muted = false;

    const observer = new MutationObserver(function (records) {
      if (muted) return;

      // Ignore our own writes to the shipping bar, or we loop.
      const relevant = records.some(function (record) {
        const target = record.target;
        if (!target || target.nodeType !== 1) return false;
        return !target.closest('[data-pnm-ship]');
      });
      if (!relevant) return;

      muted = true;
      refreshSoon();
      setTimeout(function () {
        muted = false;
      }, 300);
    });

    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (!customElements.get('pnm-cart-recommendations')) {
    customElements.define(
      'pnm-cart-recommendations',
      class PnmCartRecommendations extends HTMLElement {
        static cache = null;

        connectedCallback() {
          if (PnmCartRecommendations.cache) {
            this.innerHTML = PnmCartRecommendations.cache;
            this.hydrate();
            return;
          }
          this.load();
        }

        async load() {
          const base = this.dataset.url;
          if (!base) return;

          let html = await this.fetchSection(base);
          if (!this.hasItems(html)) {
            html = await this.fetchSection(base.replace('intent=complementary', 'intent=related'));
          }
          if (!this.hasItems(html)) return; // stays :empty, CSS hides it

          this.innerHTML = html;
          PnmCartRecommendations.cache = html; // cache only when non-empty
          this.hydrate();
        }

        async fetchSection(url) {
          try {
            const res = await fetch(url);
            if (!res.ok) return '';
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            const section = doc.querySelector('.shopify-section');
            return section ? section.innerHTML : '';
          } catch {
            return '';
          }
        }

        hasItems(html) {
          return !!html && html.includes('pnm-cart__cross-item');
        }

        hydrate() {
          this.wireAdds();
          this.wireNav();
        }

        wireAdds() {
          this.querySelectorAll('.pnm-cart__cross-add').forEach((btn) => {
            btn.addEventListener('click', async () => {
              const id = Number(btn.dataset.variantId);
              if (!id) return;
              btn.setAttribute('aria-busy', 'true');
              try {
                const res = await fetch(routes.cart_add_url, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
                  body: JSON.stringify({
                    items: [{ id, quantity: 1 }],
                    sections: 'cart-drawer,cart-icon-bubble',
                    sections_url: window.location.pathname,
                  }),
                });
                const state = await res.json();
                const drawerEl = document.querySelector('cart-drawer');
                if (drawerEl && state.sections) drawerEl.renderContents(state);
              } finally {
                btn.removeAttribute('aria-busy');
              }
            });
          });
        }

        wireNav() {
          const track = this.querySelector('.pnm-cart__cross-track');
          const prev = this.querySelector('[data-pnm-cross-prev]');
          const next = this.querySelector('[data-pnm-cross-next]');
          if (!track || !prev || !next) return;

          const step = () => {
            const item = track.querySelector('.pnm-cart__cross-item');
            return item ? item.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
          };

          prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
          next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

          const sync = () => {
            prev.toggleAttribute('disabled', track.scrollLeft <= 1);
            next.toggleAttribute('disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 1);
          };
          track.addEventListener('scroll', sync, { passive: true });
          sync();
        }
      }
    );
  }
})();